import React from 'react';
import '../../styles/SolucionesPublicitarias.css';

const SponsorDisplay = () => {
    return (
        <section className="sponsor-mode-section py-5">
            <div className="container">
                {/* Título */}
                <div className="title-container" data-aos="fade-up">
                    <h2 className="title"><span>Sponsor</span> Mode</h2>
                    <div className="title-underline"></div>
                </div>

                <div className="section-description" data-aos="fade-up">
                    <p>
                        Incorporamos Sponsor como una nueva modalidad de compra, permitiendo adquirir espacios de forma diaria y
                        optimizando la planificación de campañas de alto impacto. Estos formatos ofrecen máxima visibilidad y
                        mensajes personalizados, diseñados para captar mayor atención y generar resultados sobresalientes.
                        Son ideales para campañas de branding y la promoción de eventos o fechas clave.
                    </p>
                </div>

                <div className='row align-items-start my-5 justify-content-between'>
                    {/* Columna izquierda */}
                    <div className='col-md-12 col-lg-3'>
                        <div data-aos="fade-right" className="sponsor-box takeover-desktop text-white">
                            <div>
                                <h4><span className='fw-normal'>Sponsor</span> Takeover</h4>
                                <p>
                                    Un formato premium de alto impacto para desktop, diseñado para captar la máxima atención.
                                    Combina un diseño visualmente dominante con una integración fluida en el contenido, ideal
                                    para campañas de branding.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Columna del medio con imágenes superpuestas */}
                    <div className='col-md-12 col-lg-5 position-relative d-flex justify-content-center mt-5 mb-5 sponsor-images'>
                        <img src="assets/sponsor-mode-1.png" data-aos="zoom-in" data-aos-delay="0" alt="Laptop" className="img-fluid laptop-img img-filter" />
                        <img src="assets/sponsor-mode-3.png" data-aos="zoom-in-right" data-aos-delay="300" alt="Tablet" className="img-fluid tablet-img img-filter" />
                        <img src="assets/sponsor-mode-2.png" data-aos="zoom-in-left" data-aos-delay="600" alt="Mobile" className="img-fluid mobile-img img-filter" />
                    </div>

                    {/* Columna derecha */}
                    <div className='col-md-12 col-lg-3'>
                        <div data-aos="fade-left" className="sponsor-box takeover-mobile text-white">
                            <div>
                                <h4><span className='fw-light'>Sponsor</span> Takeover Mobile</h4>
                                <p>
                                    Una solución compuesta por dos anuncios de alto impacto, ofreciendo una experiencia inmersiva y persistente en dispositivos móviles.
                                    El FullScreen Banner asegura atención inmediata al usuario, mientras que el Footer Leaderboard refuerza el mensaje durante toda la navegación.
                                </p>
                            </div>
                        </div>
                        <div>
                            <p className="fst-italic sponsor-note text-center mt-1">(FullScreen Banner + Footer Leaderboard)</p>
                        </div>
                    </div>
                </div>



            </div>
        </section>
    );
};

export default SponsorDisplay;